import { BaseClientService, ErrorV2, ValidationErrorV2 } from "../BaseClientService";
import { NextRouter } from "next/router";
import { goErrorPage, goLoginPage } from "../../frontRouting";

export type PostContactMessageQuery = {
  contact_message_thread_id: number;
  message: string;
}
export type PostOrderMessageQuery = {
  order_message_thread_id: number;
  message: string;
}

type ListQuery = {
  message_thread_id: number;
}

export type Message = ContactMessage | OrderMessage;
export type ContactMessage = {
  id: number;
  message: string;
  sent_at: string;
  source_type: 'from_account' | 'from_member';
}
export type OrderMessage = {
  id: number;
  message: string;
  sent_at: string;
  source_type: 'from_account' | 'from_member';
}

export class FrontMessageService extends BaseClientService {

  url: string
  onError: (router: NextRouter) => Promise<void>
  onAuthError: (router: NextRouter) => Promise<void>

  constructor() {
    super();
    this.url = this.API_BASE_URL + '/api/front/messages';
    this.onError = goErrorPage
    this.onAuthError = goLoginPage
  }

  async postContactMessage(query: PostContactMessageQuery,
                           router: NextRouter,
                           setValidationError: (error: ValidationErrorV2) => void,
                           onSuccess: (contactMessage: ContactMessage) => void
  ): Promise<void> {
    const response = await fetch(`${this.url}/contact_messages`, {
      credentials: "include",
      method: 'POST',
      headers: this.headers,
      body: JSON.stringify(query)
    });
    if (response.ok) {
      onSuccess(await response.json() as ContactMessage)
    } else if (response.status === 401) {
      await this.onAuthError(router)
    } else if (response.status === 400) {
      const error = await response.json() as ErrorV2
      setValidationError(error.validation_error || {})
    } else {
      // 400エラーの場合はバリデーションエラーにしたい
      await this.onError(router)
    }
  }

  async postOrderMessage(query: PostOrderMessageQuery,
                         router: NextRouter,
                         setValidationError: (error: ValidationErrorV2) => void,
                         onSuccess: (contactMessage: ContactMessage) => void
  ): Promise<void> {
    const response = await fetch(`${this.url}/order_messages`, {
      credentials: "include",
      method: 'POST',
      headers: this.headers,
      body: JSON.stringify(query)
    });
    if (response.ok) {
      onSuccess(await response.json() as ContactMessage)
    } else if (response.status === 401) {
      await this.onAuthError(router)
    } else if (response.status === 400) {
      const error = await response.json() as ErrorV2
      setValidationError(error.validation_error || {})
    } else {
      // 400エラーの場合はバリデーションエラーにしたい
      await this.onError(router)
    }
  }

  async listContactMessage(query: ListQuery, router: NextRouter, onSuccess: (contactMessages: ContactMessage[]) => void): Promise<void> {
    const response = await fetch(this.buildUrl(`${this.url}/contact_messages`, query), {
      credentials: "include",
      headers: this.headers
    });
    if (response.ok) {
      onSuccess(await response.json() as ContactMessage[])
    } else if (response.status === 401) {
      await this.onAuthError(router)
    } else {
      // 404エラーの場合は文言を追加できればいいな
      await this.onError(router)
    }
  }

  async listOrderMessage(query: ListQuery, router: NextRouter, onSuccess: (orderMessages: OrderMessage[]) => void): Promise<void> {
    const response = await fetch(this.buildUrl(`${this.url}/order_messages`, query), {
      credentials: "include",
      headers: this.headers
    });
    if (response.ok) {
      onSuccess(await response.json() as OrderMessage[])
    } else if (response.status === 401) {
      await this.onAuthError(router)
    } else {
      // 404エラーの場合は文言を追加できればいいな
      await this.onError(router)
    }
  }
}
